export default __webpack_public_path__ + "static/media/EnergyConsumpTemplate.76597283.xlsx";